import { Component, h } from 'preact'
import { Item, ItemsList } from "./interfaces";
import Icon from "../assets";

interface Props {
    items: ItemsList,
    onChange: (items: ItemsList) => void,
    isOpen: boolean
}

interface State {
    value: string
}

function isChangeEvent (event: Event): event is ChangeEvent {
    return !!event.target && 'value' in event.target
}

class DropdownSearchbox extends Component<Props, State> {
    constructor() {
        super()
        this.setState({ value: '' })

        this.onClear = this.onClear.bind(this)
    }

    onInput (event: ChangeEvent): void {
        const input = event.target.value

        this.setState({ value: input })

        this.props.onChange(
            this.props.items.filter((item: Item) => {
                return item.title.includes(input)
            })
        )
    }

    onClear() {
        this.setState({ value: '' })
        this.props.onChange(this.props.items)
    }

    render (props: Props, state: State) {
        return (
          <div class='dropdown-searchbox'>
            <Icon icon='search'/>
            <input
              className='qa-dropdown-search-box'
              id='searchbox'
              type='text'
              placeholder='Search'
              value={state.value}
              onInput={(e) => {
                  if (isChangeEvent(e)) {
                      this.onInput(e)
                  }
              }}
            />
              {state.value && <Icon
              customClass='btn-clear-searchbox'
              icon='close'
              onClick={(e: ClickEvent) => {
                  e.stopPropagation()
                  this.onClear()
              }}
            />}
          </div>
        )
    }
}

export default DropdownSearchbox
